import { ChatDots, Github, Hammer, Search, Wallet2 } from "react-bootstrap-icons";
import { ProjectCard } from "./ProjectCard";
import { Reveal } from "./Reveal";

const GITHUB_REPOS = "https://github.com/khushi-tulsiyan?tab=repositories";

// Newest first. Add `imgUrl` to a project to show a real screenshot instead of its icon,
// and `demo` when it has a live version.
const projects = [
  {
    title: "AuctionMania",
    description: "Real-time auction platform with live bidding, a server-synced countdown and anti-sniping.",
    tags: ["Node.js", "Socket.IO", "React", "Docker"],
    Icon: Hammer,
    code: "https://github.com/khushi-tulsiyan/auctionmania",
    demo: "https://auctionmania.vercel.app",
  },
  {
    title: "Advanced RAG System",
    description: "Hybrid search (BM25 + dense vectors) with cross-encoder reranking, served as a FastAPI service.",
    tags: ["Python", "FastAPI", "FAISS"],
    Icon: Search,
    code: "https://github.com/khushi-tulsiyan/Advanced-RAG-System",
  },
  {
    title: "LLM Chatbot",
    description: "Full-stack chatbot with streaming replies, multiple LLM providers, and every call logged to Grafana dashboards.",
    tags: ["Python", "Redis", "Prometheus", "Docker"],
    Icon: ChatDots,
    code: "https://github.com/khushi-tulsiyan/chatbot-ai",
  },
  {
    title: "EventWallet",
    description: "Digital wallet with Auth0 sign-in, Razorpay top-ups and full transaction history.",
    tags: ["Next.js", "Auth0", "Razorpay"],
    Icon: Wallet2,
    code: "https://github.com/khushi-tulsiyan/wallet",
  },
];

export const Projects = () => {
  return (
    <section className="work" id="work">
      <Reveal as="h2" className="section-title">Recent projects</Reveal>
      <ul className="work-grid">
        {projects.map((project, index) => (
          <ProjectCard key={project.title} delay={(index % 2) * 120} {...project} />
        ))}
      </ul>
      <Reveal className="work-more">
        <a href={GITHUB_REPOS} className="btn btn-outline-light" target="_blank" rel="noopener noreferrer">
          <Github size={18} aria-hidden="true" /> See all projects on GitHub
        </a>
      </Reveal>
    </section>
  )
}
